import { createContext, defaultValue, useContext } from 'react';

import { frameStore } from 'apps/components/Frame/appManager';
import { UiPosition } from 'libs/rendering/gltf/config';
import { FrameSidebarWidth } from 'styles/constants';
import { clientStore } from 'apps/client/app';

import { useViewerControl } from './gltf/hooks';

const ChatControlContext = createContext(defaultValue);

export const ChatControlProvider = ChatControlContext.Provider;
export const useChatControl = () => useContext(ChatControlContext);

export const useViewerWidth = () => {
  const viewerControl = useViewerControl();
  const chatControl = useChatControl();

  const calcRightOffset = () => {
    let offset = 0;
    const chatOffset =
      !viewerControl.isPreview && chatControl.chatVisible
        ? UiPosition.bigPanel
        : 0;
    offset += chatOffset;
    const pageHasRightPanel =
      frameStore.canShowRightPanel && !chatControl.chatVisible;
    if (pageHasRightPanel) {
      offset += UiPosition.largePanel;
    }
    return offset;
  };
  const rightOffset = calcRightOffset();

  const calcViewerWidth = offset => {
    let viewerWidth = '100%';
    if (!clientStore.isMobile) {
      let availableW = clientStore.windowWidth - offset;
      availableW -= FrameSidebarWidth;

      const minW = UiPosition.panel;
      if (availableW > minW) {
        viewerWidth = `${availableW.toFixed().toString()}px`;
      } else {
        viewerWidth = `${minW.toFixed().toString()}px`;
      }
    }
    return viewerWidth;
  };
  const viewerWidth = calcViewerWidth(rightOffset);

  return [viewerWidth, rightOffset];
};
